module.exports = __webpack_public_path__ + "2bf0cd02c4ba32facc1886fea329a4c0.MP3";